import './ClassBranches.scss'

import { DeleteOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Col, Input, Modal, notification, Row, Table } from 'antd'
import DeleteModal from 'components/okulyonetim-admin/delete-modal/DeleteModal'
import { saveAs } from 'file-saver'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import * as XLSX from 'xlsx'

import AppContext from '../../../../context/AppContext'
import { useOkulSinifSubeleriQuery, useSinifSubeSilMutation } from '../../../../gql/GeneratedGraphqlTypes'
import Spinner from '../../../spinner/Spinner'
import { ReactComponent as AktarIcon } from '../okul-siparis-page/icons/aktar.svg'
const { Search } = Input

const ClassBranches: React.FC = () => {
  const navigate = useNavigate()
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [searchValue, setSearchValue] = useState<string>('')
  const { okul } = useContext(AppContext)
  const { data, loading, refetch, error } = useOkulSinifSubeleriQuery({
    variables: {
      sube_id: okul?.id,
      arama: searchValue || null,
    },
    fetchPolicy: 'network-only',
  })
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false)
  const [deleteId, setDeleteId] = useState<string | null>(null)
  const [sinifSubeSil] = useSinifSubeSilMutation()
  const [submitting, setSubmitting] = useState(false)
  const [modalMessage, setModalMessage] = useState<{ title: string; reasons: string[] }[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalTitle, setModalTitle] = useState('')
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const showDeleteModal = (ids: string[]) => {
    setDeleteId(ids.join(','))
    setIsDeleteModalVisible(true)
  }

  // Filtreleme değiştikçe veriyi tekrar çek
  useEffect(() => {
    refetch()
  }, [searchValue, refetch])

  const handleSearch = () => {
    setSearchValue(searchTerm)
  }

  if (loading) {
    return <Spinner showSpinner={loading} color="red" />
  }

  if (error) {
    console.error(error)
    navigate('/')
    return null
  }

  const filteredData = data?.okulSinifSubeleri?.sinif_subeleri?.filter(Boolean) ?? []
  const totalItems = filteredData.length;
  const displayedItems = selectedRowKeys.length;
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      sorter: (a: any, b: any) => a.id - b.id,
      defaultSortOrder: 'descend' as 'descend' | 'ascend' | undefined,
    },
    {
      title: 'Kampus',
      dataIndex: 'kampus',
      key: 'kampus',
      sorter: (a: any, b: any) => a.kampus.localeCompare(b.kampus),
    },
    {
      title: 'Üst Sınıf Şubesi',
      dataIndex: 'ust_sinif_subesi',
      key: 'ust_sinif_subesi',
      sorter: (a: any, b: any) => (a.ust_sinif_subesi ?? '').localeCompare(b.ust_sinif_subesi ?? ''),
    },
    {
      title: 'İsim',
      dataIndex: 'isim',
      key: 'isim',
      sorter: (a: any, b: any) => a.isim.localeCompare(b.isim),
    },
    {
      title: '',
      key: 'detail',
      render: (record: any) => (
        <Button
          className="okul-yonetim-admin-detail-button"
          onClick={() => navigate(`/okulyonetimadmin/sinifkategorisi/${record.id}`)}
        >
          Detay
        </Button>
      ),
    },
  ]
  const exportAllToExcel = () => {
    const worksheetData: any[] = []

    const headers = ['id','isim','kampus_id', 'kampus_adi','ust_kategori_id','ust_kategori_adi']
    worksheetData.push(headers)

    data?.okulSinifSubeleri?.sinif_subeleri.forEach((sinifSubeler: any) => {
      const transformedData = [sinifSubeler.id,sinifSubeler.isim || '',sinifSubeler.kampus_id,  sinifSubeler.kampus || '', sinifSubeler.ust_sinif_subesi_id || '', sinifSubeler.ust_sinif_subesi || '' ]
      worksheetData.push(transformedData)
    })

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)

    const colWidths = worksheetData[0].map((_: string, colIndex: number) =>
      Math.max(...worksheetData.map((row) => (row[colIndex] ? row[colIndex].toString().length : 10))),
    )
    worksheet['!cols'] = colWidths.map((width: number) => ({ wch: width }))

    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'TümVeriler')
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
    saveAs(new Blob([excelBuffer]), `sinifKategorileri.xlsx`)
  }

  const handleDelete = async (ids: string) => {
    setSubmitting(true)
    const idList: number[] = ids.split(',').map((id) => Number(id))

    try {
      const response = await sinifSubeSil({
        variables: {
          id: idList,
        },
      })

      if (response.data?.sinifSubeSil.success && !response.data.sinifSubeSil.silinemeyenler?.length) {
        notification.success({
          message: '',
          description: `${response.data?.sinifSubeSil?.message}`,
          duration: 6,
        })
        setIsDeleteModalVisible(false)
        setSelectedRowKeys([])
        await refetch()
      } else {
        setModalTitle('Bir hata oluştu.')
        setIsModalOpen(true)

        const silinenler = response.data?.sinifSubeSil?.silinenler?.map((item) => ({
          title: `Silindi: ${item?.isim}`,
          reasons: [],
        })) ?? [];

        const silinemeyenler = response.data?.sinifSubeSil?.silinemeyenler?.map((item) => ({
          title: item?.isim || "Bilinmeyen Sınıf",
          reasons: (item?.neden || []).filter((reason): reason is string => Boolean(reason)), // Null veya undefined değerleri temizle
        })) ?? [];

        setModalMessage([...silinenler, ...silinemeyenler]);

      }
    } catch (error) {
      notification.error({
        message: '',
        description: 'Listeyi gönderirken bir hata oluştu.',
        duration: 6,
      })
    } finally {
      setSubmitting(false)
    }
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }
  if (submitting) {
    return <Spinner showSpinner={submitting} color="red" />
  }
  return (
    <div className="okul-sinif-kategorisi-page">
      <div className="okul-sepeti-admin-header">
        <h1>Sınıf Kategorileri </h1>
        <div className='export-buttons'>
          <Button onClick={exportAllToExcel} className="export-button">
            <AktarIcon/> Dışa Aktar{' '}
          </Button>
          <Button onClick={() => navigate('/okulyonetimadmin/sinifkategorisisaktar')} className="export-button">
            <AktarIcon/> İçe Aktar
          </Button>
        </div>
      </div>
      <Row justify={'space-between'} gutter={8} className="filter-section">
        <Col span={6}>
          <Search
              placeholder="Sınıf Kategorisi Ara"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onSearch={handleSearch}
              allowClear
              enterButton={
                <div className="search-suffix-div">
                Ara <SearchOutlined />{' '}
              </div>
            }
          />
        </Col>
        <div className="button-right">
          <Button onClick={() => navigate('/okulyonetimadmin/sinifkategorisi/sinif-sube-ekle')}>
            Sınıf Kategorisi Ekle
          </Button>
        </div>
      </Row>

      <Table
        dataSource={filteredData as object[]}
        columns={columns}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
          total: totalItems,
          showTotal: (total) => (
              <div style={{display: 'flex', alignItems: 'center', gap: '16px'}}>
                <Button
                    style={{
                      display: selectedRowKeys.length === 0 ? 'none' : '',
                    }}
                    icon={<DeleteOutlined/>}
                    onClick={() => showDeleteModal(selectedRowKeys.map((id) => id.toString()))}
                    type="primary"
                    danger
                >
                  Seçilen {selectedRowKeys.length} Sınıf Şubelerini Sil
                </Button>

                <span style={{marginLeft: '10px'}}> {/* Buton ile metin arasına boşluk koyuyoruz */}
                  Seçilen: {displayedItems} / Toplam: {total}
               </span>
              </div>
          ),
          onChange: (page, size) => {
            setCurrentPage(page);
            setPageSize(size);
          },
        }}
        loading={loading}
        rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-light' : 'table-row-dark')}
        rowKey="id"
        className="okul-yonetim-admin-table"
        rowSelection={{
          type: 'checkbox',
          selectedRowKeys,
          onChange: (keys) => setSelectedRowKeys(keys as string[]),
          ...Selection,
        }}
      />
      <DeleteModal
        title="Seçilen Sınıf Şubelerini Sil"
        id={deleteId || ''}
        visible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onDelete={handleDelete}
      />
      <Modal
          footer={<Button onClick={handleCancel}>Kapat</Button>}
          onCancel={handleCancel}
          title={modalTitle}
          open={isModalOpen}
      >
        <ul>
          {modalMessage.map((message, index) => (
              <li key={index}>
                <strong>{message.title}</strong>
                {message.reasons.length > 0 && (
                    <ul>
                      {message.reasons.map((reason, subIndex) => {
                        const sinifMatch = reason.match(/Sınıf ID:\s*(\d+)/);
                        const kategoriMatch = reason.match(/Kategori ID:\s*(\d+)/);

                        if (sinifMatch) {
                          const sinifId = sinifMatch[1];
                          return (
                              <li key={`${index}-${subIndex}`}>
                                {reason.replace(`Sınıf ID: ${sinifId}`, '')}
                                <a onClick={() => navigate(`/okulyonetimadmin/sinif/${sinifId}`)}
                                   style={{cursor: 'pointer', marginLeft: 4, color: '#1677ff', textDecoration: 'underline'}}>
                                  (Sınıf ID: {sinifId})
                                </a>
                              </li>
                          );
                        } else if (kategoriMatch) {
                          const kategoriId = kategoriMatch[1];
                          return (
                              <li key={`${index}-${subIndex}`}>
                                {reason.replace(`Kategori ID: ${kategoriId}`, '')}
                                <a onClick={() => navigate(`/okulyonetimadmin/sinifkategorisi/${kategoriId}`)}
                                   style={{
                                     cursor: 'pointer',
                                     marginLeft: 4,
                                     color: '#1677ff',
                                     textDecoration: 'underline'
                                   }}>
                                  (Kategori ID: {kategoriId})
                                </a>
                              </li>
                          );
                        }

                        return <li key={`${index}-${subIndex}`}>{reason}</li>;
                      })}
                    </ul>
                )}
              </li>
          ))}
        </ul>
      </Modal>
    </div>
  )
}

export default ClassBranches
